import { Network } from ':fat/core/networks';
import { Xpub } from ':fat/database/schema-types';

import { getBaseUrl } from './client';

export type BroadcastTransactionResponse = {
  txid: string;
  status: 'SUCCESS' | 'FAILED';
  error_message: string;
  error_code: number;
};

export async function broadcastTransaction(network: Network, hex: string, xpubkey: Xpub['key']) {
  const response = await fetch(`${getBaseUrl()}/v2/funds-access/${network}/txs/submit`, {
    method: 'POST',
    body: JSON.stringify({ signed_tx: hex, xpub: xpubkey }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const body = (await response.json()) as { data: BroadcastTransactionResponse };
  return body.data;
}
